import { Request } from '@/core/api/request'

class SearchRequest extends Request {
  URL = 'search/'

  send({ query, dateStart, dateEnd, sourceId, page = 1, pageSize = 20, mlgSample = false }) {
    const filter = {
      'query': query,
      'date_start': dateStart,
      'date_end': dateEnd,
      'include_sources': [sourceId] ?? [],
      'page': page,
      'page_size': pageSize,
      'mlg_sample': mlgSample,
    }

    return this.axios.post(this.URL, filter)
  }
}

export { SearchRequest }
